import React, { useEffect, useState } from "react";
import ComparisionChart from "../components/comparision-chart";
import { statesDaily } from "../utils/api-urls";
import Example from "../components/gender-chart";

const ComparisonCharts = () => {
  const [comparisonChartsData, setComparisonChartsData] = useState({});

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const response = await fetch(statesDaily);
    const data = await response.json();
    const confirmedCases = getCasesTypes(data.states_daily, "Confirmed");
    const recoveredCases = getCasesTypes(data.states_daily, "Recovered");
    const deceasedCases = getCasesTypes(data.states_daily, "Deceased");

    setComparisonChartsData({ confirmedCases, recoveredCases, deceasedCases });
  };

  const getCasesTypes = (data, type) => {
    return data
      .filter((dayData) => dayData.status === type)
      .map((dayData) => {
        let obj = {};
        for (let [key, value] of Object.entries(dayData)) {
          if (key !== "date" && key !== "status") {
            obj[key] = +value;
          } else {
            obj[key] = value;
          }
        }
        return obj;
      });
  };

  // let ComparisionChart = ComparisionChart = convertToNumber();

  return (
    <>
      {Object.keys(comparisonChartsData).length !== 0 ? (
        <>
          <h2 style={{ marginLeft: "50px", fontWeight: "100" }}>
            Compare States Data
          </h2>
          <div className="comparison-section">
            <ComparisionChart
              label="Daily Confirmed"
              id="confirmed-cases"
              {...comparisonChartsData.confirmedCases}
            />
            <ComparisionChart
              label="Daily Recovered"
              id="recovered-cases"
              {...comparisonChartsData.recoveredCases}
            />
            <ComparisionChart
              label="Daily Deceased"
              id="deceased-cases"
              {...comparisonChartsData.deceasedCases}
            />
            <div className="gender-chart">
              <Example />
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default ComparisonCharts;
